import { SUPPORT_EMAIL } from "../../lib/constants";

export default function EmailComponent() {
  return (
    <a 
      href={`mailto:${SUPPORT_EMAIL}`}
      style={{
        fontWeight: '500',
        color: '#2563eb',
        textDecoration: 'underline'
      }}
      onMouseEnter={(e) => e.currentTarget.style.color = '#1d4ed8'}
      onMouseLeave={(e) => e.currentTarget.style.color = '#2563eb'}
    >
      {SUPPORT_EMAIL}
    </a>
  );
}